import { loadDashboardFeatureFlags } from '@telstra-connect/dashboard/feature-flags/load-flags';
import { loadServiceRequestsFeatureFlags } from '@telstra-connect/service-requests/feature-flags/load-flags';
import { FeatureFlags as SelfServiceMigrationFlags } from '@telstra-connect/self-service-migration';

import global from '@applications';

export const setFeatureFlags = () => {
    const getFlagsConfigFromState = () => global.applications

    // Non application-specific flags
    loadDashboardFeatureFlags(getFlagsConfigFromState);

    // All applications
    loadServiceRequestsFeatureFlags(getFlagsConfigFromState);
    SelfServiceMigrationFlags.loadFeatureFlags(getFlagsConfigFromState);
};
